import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "st_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, qty = 1) => {
    setItems((cur) => {
      const found = cur.find((i) => i.id === product.id);
      const maxAvail = Number(product.quantity || 0);
      if (found) {
        const newQty = Math.min(found.qty + qty, maxAvail);
        return cur.map((i) => (i.id === product.id ? { ...i, qty: newQty } : i));
      }
      return [
        ...cur,
        {
          id: product.id,
          title: product.title,
          price: product.sale_price ?? product.price,
          original_price: product.price,
          image: product.images?.[0] || null,
          max: maxAvail,
          qty: Math.min(qty, maxAvail),
        },
      ];
    });
  };

  const updateQty = (id, qty) => {
    setItems((cur) =>
      cur.map((i) => (i.id === id ? { ...i, qty: Math.max(1, Math.min(qty, i.max)) } : i))
    );
  };

  const removeItem = (id) => setItems((cur) => cur.filter((i) => i.id !== id));
  const clear = () => setItems([]);

  const total = useMemo(() => items.reduce((s, i) => s + i.price * i.qty, 0), [items]);
  const count = useMemo(() => items.reduce((s, i) => s + i.qty, 0), [items]);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, removeItem, clear, total, count }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
